<div class="cart ">
  <div class="mx:flex justify-between bg-white">
    <customer-select class="mr-8 order-2"></customer-select>
    <breadcrumb-navigation class="order-1" [titles]="['ORDER_FAILED'| translate]"></breadcrumb-navigation>
  </div>
  <div class="bg-darkGrey flex flex-wrap gap-x-6 pt-6 mx:px-8 sm:px-4">
    <div class="flex-1 min-w-[250px] bg-white mx:p-4 sm:p-2">
      <div class="bg-error text-base min-h-[48px]  py-2 flex-v-center mb-2 justify-between" *ngIf="cartData?.errorMessage?.length>0">
        <div class="flex items-center">
          <svg-icon [iconName]="'new/info.svg'" [size]="20" class="mr-3 ml-4"></svg-icon>
          <div>
            <div *ngIf="cartData?.errorMessage?.length>0">{{'CART_ERROR_TIPS'|translate}}</div>
            <div *ngFor="let error of cartData?.errorMessage; ">{{error.severity==='E'?error.message:''}}</div>
          </div>
        </div>
      </div>
      <ul class="flex-1 min-w-[250px] bg-white">
        <li *ngFor="let item of productList; let i = index" [ngClass]="{'bg-white':!(item.errorTypes.includes('error') ||  item.errorTypes.includes('stock_error')),'bg-errorBg':item.errorTypes.includes('error') || item.errorTypes.includes('stock_error')}">
          <div class="text-base flex items-center bg-warning h-[48px] p-2" *ngIf="isInPromotion(item)">
            <svg-icon [iconName]="'new/info.svg'" [size]="20" class="mr-3 ml-2"></svg-icon>
            <div>
              <div *ngFor="let msg of getMessageByPromotion(item.errorMessages); ">{{msg}}</div>
            </div>
          </div>
          <div class="flex flex-wrap mx:px-4 mx:pt-4 sm:px-2 sm:pt-2">
            <!-- material no & checkbox -->
            <div class="w-full mx:w-1/2 flex items-center flex-wrap font-bold"
              [ngClass]="{'text-greyDisable':item.errorTypes.includes('invalid_error')}">
              <span class="sm:min-w-[24px] mx:min-w-[42px] sm:ml-2 mx:ml-4">{{item.itemNo}}</span>
              <span>{{item.inputMaterialNumber || '--'}}</span>
              <div class="sm:hidden mx:flex items-center ml-4 h-[28px] w-[146px] bg-promotion text-green"
                *ngIf="isInPromotion(item)">
                <svg-icon [iconName]="'new/promotions.svg'" [size]="20" class="px-2"></svg-icon>
                <span class="font-normal">{{'IN_PROMOTION'|translate}}</span>
              </div>
            </div>
            <div class="sm:flex mx:hidden items-center ml-[64px] h-[28px] w-[146px] bg-promotion text-green"
                *ngIf="isInPromotion(item)">
                <svg-icon [iconName]="'new/promotions.svg'" [size]="20" class="px-2"></svg-icon>
                <span class="font-normal">{{'IN_PROMOTION'|translate}}</span>
              </div>
            <!-- wait simulate operation -->
            <div class="order-3 mx:order-2 w-full mx:w-1/2 sm:ml-8 sm:mb-2">
              <div class="flex flex-row-reverse sm:justify-end items-center">
                <svg-icon [iconName]="'new/notification.svg'" nz-popover [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="msgTemplate" class="mr-4"  *ngIf="item.errorMessages.length>0"></svg-icon>
                <div class="flex items-center mr-4"
                  *ngIf="getMessagesByType(item.errorMessages,'E').length===0 && item.isSimulated">
                  <svg-icon [iconName]="'new/orderable.svg'"  class="mr-2"></svg-icon>
                  <span class="text-base text-warningTips">{{"ORDERABLE"|translate}}</span>
                </div>
                <div class="flex items-center mr-4" *ngIf="getMessagesByType(item.errorMessages,'E').length>0">
                 
                  <svg-icon [iconName]="'new/not_orderable.svg'" class="mr-2"></svg-icon>
                  <span class="text-base text-errorTips"
                  *ngIf="getMessagesByType(item.errorMessages,'E').length>0">{{"NOT_ORDERABLE"|translate}}</span>
                </div>
                <div class="flex items-center mr-4"
                  *ngIf="!item.isSimulated && getMessagesByType(item.errorMessages,'E').length===0">
                 <svg-icon [iconName]="'new/wait_simulate.svg'"  class="mr-2"></svg-icon>
                 <span class="text-base text-grey700"
                 *ngIf="!item.isSimulated && getMessagesByType(item.errorMessages,'E').length===0">{{"WAIT_SIMULATION"|translate}}</span>
                 
      
                </div>
              </div>
          </div>
          <!-- info -->
          <div class="order-2 mx:order-3 w-full mt-2"
            [ngClass]="{'text-greyDisable':item.errorTypes.includes('invalid_error')}">
            <div class="mx:ml-[58px] flex flex-wrap justify-between">
              <!-- product & material no -->
              <div class="sm:ml-8  mx:mb-4 sm:mb-1 w-full mx:w-[calc(25%-0.75rem)] min-w-[220px]" >
                <div class="line-height30 h-[30px] mb-1">
                  <span class="mr-2 truncate" [attr.title]="item.productName">{{item.productName || '--'}}</span>
                  <svg-icon [iconName]="'new/arrow.svg'" nz-popover [nzPopoverPlacement]="'top'"
                  [nzPopoverContent]="infoTemplate" [size]="10" *ngIf="item.productName"></svg-icon>
                </div>
                <div class="h-[40px] line-height40">{{item.materialNumber || '--'}}</div>
              </div>
      
              <!-- qty & moq -->
              <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] sm:ml-8  mx:mb-4 sm:mb-1">
                <div class="h-[30px] line-height30">{{"QUANTITY"|translate}}</div>
                <!-- -->
                
                <div class="h-[40px] line-height40 w-[200px] mb-1">
                  {{item.quantity || '--'}}
                </div>
                <div class="mb-1 text-grey900" *ngIf="item.inputQuantity!=item.quantity">
                  {{"INPUT_NO"|translate}}:<span class="ml-2">{{item.inputQuantity}}</span>
                </div>
                <div class="text-grey900">
                  {{"MOQ"|translate}}:<span class="ml-2">{{item.minimumOrderQuantity}}</span>
                </div>
      
              </div>
      
              <!-- expected date -->
              <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] sm:ml-8 mx:mb-4 sm:mb-1">
                <div class="h-[30px] line-height30">{{"ADD_DATE"|translate}}</div>
                <div class="h-[40px] w-[228px] mb-1 line-height40 flex items-center">
                   <span> {{item.expectedDate}}</span>
                  <svg-icon class="ml-1" [size]="20" *ngIf="item.stockQuantity!==''"
                    [iconName]="item.stockQuantity===0?'new/red.svg':(item.quantity<=item.stockQuantity?'new/green.svg':'new/yellow.svg')"></svg-icon>
                </div>
                <div *ngIf="item.simulateDeliveryInfoList.length>0&&item.isSimulated">
                  <div class="mb-1" *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(item.simulateDeliveryInfoList);"
                    [ngClass]="{'color-warning':deliveryInfo.deliveryDate>item.expectedDate,'color-green':deliveryInfo.deliveryDate<=item.expectedDate}">
                    {{deliveryInfo.deliveryDate}}<ng-container *ngIf="shouldShowDeliveryQuantity()">:<span class="ml-2">{{deliveryInfo.quantity}}</span></ng-container>
                  </div>
                </div>
              </div>
      
              <!-- price -->
              <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] sm:ml-8 mx:mb-4 sm:mb-1">
                <div class="mb-1  h-[30px] line-height30" *ngIf="item.isSimulated">
                  {{'CART_TOTAL_VALUE' | translate}}:<span class="ml-2 text-greyDisable">{{item.totalAmount.currency}}
                    {{(item.totalAmount.value | number: '1.2-2') || '--'}}</span>
                </div>
                <div class="mb-1 h-[40px] line-height40" *ngIf="item.isSimulated">
                  {{'NET_VALUE' | translate}}:<span class="ml-2 mr-2 text-greyDisable">{{item.netValue.currency}} {{(item.netValue.value | number:
                    '1.2-2') || '--'}}</span>
                  <svg-icon [iconName]="'new/arrow-grey.svg'" [size]="10" class="text-greyDisable" nz-popover [nzPopoverPlacement]="'top'"
                  [nzPopoverContent]="priceTemplate"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="mx:ml-[58px] sm:ml-8 order-4 mx:mb-4 sm:mb-1 line" *ngIf="isInPromotion(item)"></div>
          </div>
          <!-- promotions -->
          <div *ngIf="item.isSimulated" class="mx:px-4 mx:pb-4 sm:px-2 sm:pb-2">
            <div class="ml-[58px] sm:ml-8 " *ngFor="let promotion of item.components; let j = index;">
              <!-- item  & material -->
              <div class="w-full mx:w-1/2 flex items-center flex-wrap font-bold">
                <span class="mr-4">{{promotion.itemNo}}</span>
                <span>{{promotion.materialNumber || '--'}}</span>
                <div *ngIf="promotion.isGift && item.isSimulated"
                  class="sm:hidden mx:flex items-center ml-4  h-[28px] w-[116px] bg-purpleBg text-purple">
                  <svg-icon [iconName]="'new/gift.svg'" class="px-2"></svg-icon>
                  <span class="font-normal">{{'GIVEAWAY'|translate}}</span>
                </div>
              </div>
              <div *ngIf="promotion.isGift && item.isSimulated"
                  class="sm:flex mx:hidden items-center  ml-[36px]  h-[28px] w-[116px] bg-purpleBg text-purple">
                  <svg-icon [iconName]="'new/gift.svg'" class="px-2"></svg-icon>
                  <span class="font-normal">{{'GIVEAWAY'|translate}}</span>
                </div>
              <!-- promotions info -->
              <div class="flex flex-wrap justify-between pt-2">
                <!-- product & material no -->
                <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] mx:mb-4 sm:mb-1">
                  <div class="line-height30 h-[30px] mb-1">
                    <span class="mr-2 truncate" [attr.title]="promotion.productName">{{promotion.productName || '--'}}</span>
                    <svg-icon [iconName]="'new/arrow.svg'" [size]="10" nz-popover [nzPopoverPlacement]="'top'"
                    [nzPopoverContent]="promotionInfoTemplate" *ngIf="promotion.productName"></svg-icon>
                  </div>
                  <div class="h-[30px] line-height30">{{promotion.materialNumber || '--'}}</div>
                </div>
      
                <!-- qty & moq -->
                <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] mx:mb-4 sm:mb-1">
                  <div class="h-[30px] line-height30 w-[220px] mb-1">{{"QUANTITY"|translate}}</div>
                  <div class="text-greyDisable h-[30px] line-height30">{{promotion.quantity || '--'}}</div>
                </div>
      
                <!-- expected date -->
                <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] mx:mb-4 sm:mb-1">
                  <div class="mb-1 h-[30px] line-height30 w-[220px]">{{"ADD_DATE"|translate}}</div>
                  <div class="h-[30px] line-height30 mb-1">
                    <span>{{item.expectedDate}}</span>
                    <svg-icon class="ml-2" [size]="20" *ngIf="!item.isSimulated && promotion.stockQuantity!==''"
                      [iconName]="promotion.stockQuantity===0?'new/red.svg':(promotion.quantity<=promotion.stockQuantity?'new/green.svg':'new/yellow.svg')"></svg-icon>
                  </div>
                  <div *ngIf="promotion.simulateDeliveryInfoList.length>0&&item.isSimulated">
                    <div class="mb-1 h-[30px] line-height30" *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(promotion.simulateDeliveryInfoList);"
                      [ngClass]="{'text-yellow':deliveryInfo.deliveryDate>item.expectedDate,'text-warningTips':deliveryInfo.deliveryDate<=item.expectedDate}">
                      {{deliveryInfo.deliveryDate}}<ng-container *ngIf="shouldShowDeliveryQuantity()">:<span class="ml-2">{{deliveryInfo.quantity}}</span></ng-container>
                    </div>
                  </div>
                </div>
      
                <!-- price -->
                <div class="w-full mx:w-[calc(25%-0.75rem)] min-w-[220px] mx:mb-4 sm:mb-1">
                  <div class="mb-1  h-[30px] line-height30 w-[220px]">
                    {{'NET_PRICE' | translate}}:<span class="ml-2 text-greyDisable">{{promotion.netPrice.currency}}
                      {{(promotion.netPrice.value | number: '1.2-2') || '--'}}</span>
                  </div>
                </div>
      
                <ng-template #promotionInfoTemplate>
                  <div class="price-info">
                    <div class="flex">
                      <span class="info-title color-black font16-w500">{{"EAN" | translate}}:</span>
                      <span class="color-grey7C font16-w500">{{promotion.ean || '--'}}</span>
                    </div>
                    <div class="flex">
                      <span class="info-title color-black font16-w500">{{"CART_VOLUME" | translate}}:</span>
                      <span class="color-grey font16-w500">{{(promotion.shipmentDimension?.totalVolume | number: '1.2-2') + promotion.shipmentDimension?.unitOfVolume || '--'}}</span>
                    </div>
                    <div class="flex">
                      <span class="info-title color-black font16-w500">{{"CART_WEIGHT" | translate}}:</span>
                      <span class="color-grey font16-w500">{{(promotion.shipmentDimension?.totalWeight | number: '1.2-2') + promotion.shipmentDimension?.unitOfWeight || '--'}}</span>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
      
          <!-- error msg -->
          <div class="error_msg pl-10 pr-4 pb-4" *ngIf="getMessagesExcludingPromotion(item.errorMessages).length>0">
            <p class="text-errorTips" [ngClass]="{'text-errorTips':msg.severity==='E','text-warningTips':msg.severity==='W'}"
              *ngFor="let msg of getMessagesExcludingPromotion(item.errorMessages)">{{msg.message}}</p>
          </div>
      
          <ng-template #msgTemplate>
            <div class="msg_tips">
              <ng-container>
                <div class="flex" *ngFor="let msg of item.errorMessages">
                  <!-- <i class="tip_item"></i> -->
                  <p>{{msg.message}}</p>
                </div>
              </ng-container>
      
            </div>
          </ng-template>
      
          <ng-template #infoTemplate>
            <div class="price-info">
              <div class="flex">
                <span class="info-title color-black font16-w500">{{"EAN" | translate}}:</span>
                <span class="color-grey7C font16-w500">{{item.ean || '--'}}</span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500">{{"CART_VOLUME" | translate}}:</span>
                <span class="color-grey font16-w500">{{(item.shipmentDimension?.totalVolume | number: '1.2-2') + item.shipmentDimension?.unitOfVolume || '--'}}</span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500">{{"CART_WEIGHT" | translate}}:</span>
                <span class="color-grey font16-w500">{{(item.shipmentDimension?.totalWeight | number: '1.2-2') + item.shipmentDimension?.unitOfWeight || '--'}}</span>
              </div>
            </div>
          </ng-template>
      
          <ng-template #priceTemplate>
            <div class="price-info">
              <div class="flex">
                <span class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w700">{{"CART_TOTAL_VALUE" | translate}}:</span>
                <span class="color-blue font16-w700">{{item.totalAmount.currency}} {{(item.totalAmount.value | number: '1.2-2')  || '--'}}</span>
              </div>
              <div class="flex-v-center">
                <span class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500">{{"NET_PRICE" | translate}}:</span>
                <span class="color-grey7C font16-w500">{{item.netPrice.currency}} {{(item.netPrice.value | number: '1.2-2') || '--'}}</span>
              </div>
              <div class="flex">
                <span class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500">{{"NET_VALUE" | translate}}:</span>
                <span class="color-grey font16-w500">{{item.netValue.currency}} {{(item.netValue.value | number: '1.2-2') || '--'}}</span>
              </div>
              <div class="flex">
                <span class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500">{{"TAX" | translate}}:</span>
                <span class="color-grey font16-w500">{{item.tax.currency}} {{(item.tax.value | number: '1.2-2') || '--'}}</span>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="w-[440px] md:w-full sm:w-full sm:mt-2 md:mt-2 ">
      <div class="w-full cursor-pointer mb-6 primary-small-btn bg-primaryBlue text-white" (click)="reOrder(productList)">
        <svg-icon [iconName]="'new/arrow-right.svg'" [size]="24" class="mr6"></svg-icon>
        <span>{{"REORDER"|translate}}</span> 
      </div>
      <!-- order summary -->
      <div class="cart_content_po_wrap p-4 bg-white">
        <h3 class="font-bold">{{"ORDER_SUMMARY"|translate}}</h3>
        <div class="line my-4"></div>
        <form>
          <h3 class="font-bold mb-1.5" *ngIf="country==='/oes' && salesOffice!='SOC'">{{"BRAND"|translate}}</h3>
          <!-- brand -->
          <div class="h-[48px] pl-4  bg-darkGrey leading-12" *ngIf="country==='/oes' && salesOffice!='SOC'">{{cartData?.simulateQuery?.brand}}</div>
          <!-- price detail -->
          <div class="mb-4">
            <h3 class="mb-1.5 font-bold">{{"CART_TOTAL"|translate}}</h3>
            <div class="bg-darkGrey p-4">
              <p class="flex-between text-base items-center mb-1">
                <span>{{"CART_TOTAL_ITEMS"|translate}}</span><span class="text-greyDisable">{{
                  productList.length }}
                </span>
              </p>
              <p class="flex-between text-base items-center mb-1">
                <span>{{"GROSS_VALUE"|translate}}</span><span class="text-greyDisable">{{
                  (cartData.totalAmount?.currency || "--") + '&nbsp;' +
                  (cartData.totalAmount.value?(cartData.totalAmount.value| number : "1.2-2"):"")}}
                </span>
              </p>
              <p class="flex-between text-base items-center mb-1">
                <span>{{"NET_VALUE"|translate}}</span><span class="text-greyDisable">{{
                  (cartData.netValue?.currency || "--") + '&nbsp;' +
                  (cartData.netValue.value?(cartData.netValue.value| number : "1.2-2"):"")}}
                </span>
              </p>
              <p class="flex-between items-center mb-1 text-base ">
                <span>{{"TAX"|translate}}</span><span class="text-greyDisable">{{
                (cartData.tax?.currency ||
                  "--") + '&nbsp;' + (cartData.tax.value ?(cartData.tax.value| number :
                  "1.2-2"):"")}}
                </span>
              </p>
              <p class="flex-between text-base mb-1 items-center ">
                <span class="text-base">{{"PROMOTION"|translate}}</span><span class="text-greyDisable">{{
                  (cartData.bonusDiscount?.currency || "--") + '&nbsp;'
                  + (cartData.bonusDiscount.value?(cartData.bonusDiscount.value| number : "1.2-2"):"")}}
                </span>
              </p>
            </div>
          </div>
          <!-- po -->
          <h3 class="font-bold mb-1.5">{{"CART_PO"|translate}}</h3>
          <div class="mb-4">
            <div class="h-[48px] pl-4 bg-darkGrey leading-12">{{cartData?.simulateQuery?.poNumber}}</div>
          </div>
          <h3 class="font-bold mb-1.5">{{"CART_PROCESS_DESC"|translate}}</h3>
          <div class="h-[48px] pl-4 bg-darkGrey leading-12 mb-4">{{cartData?.simulateQuery?.orderType
            }}</div>
          <!--<p class="font-bold mb-1.5" *ngIf="cartData?.simulateQuery?.orderType==='Rush_Sales'">
            {{"DISPATCH_TYPE"|translate}}</p>
             <div class="h-[48px] pl-4 bg-darkGrey leading-12">{{cartData?.simulateQuery?.dispatchType}}</div> -->
          <!-- <p class="mb-1.5 font-bold">{{"SHIPMENT_&_DELIVERY"|translate}}</p>
          <div class="mb-4">
            <label formControlName="completeDelivery" nz-checkbox>
              <span class="color-black">{{"COMPLETE_DELIVERY"|translate}}</span> {{"SHIPMENT_TIPS"|translate}}
            </label>
          </div> -->
          <!-- expected date -->
          <p class="mb-1.5 font-bold" *ngIf="cartData?.simulateQuery?.completeDelivery===true">
            {{"CART_DELIVERY_DATE"|translate}}</p>
            <div class="h-[48px] pl-4 bg-darkGrey leading-12 mb-4" *ngIf="cartData?.simulateQuery?.completeDelivery===true">{{cartData?.simulateQuery?.deliveryDate}}</div>
          <!-- shipping address -->
          <div>
            <div class="font-bold mb-1.5">{{"CART_SHIPPING_ADDRESS"|translate}}</div>
            <div class="shipping_address_content bg-darkGrey" [ngClass]="{ 'address-error': addressError }">
              <div>
                <p class="truncate" [attr.title]="cartData?.shippingAddress?.customerName">{{ cartData?.shippingAddress?.customerName }}</p>
                <p class="truncate" [attr.title]="cartData?.shippingAddress?.street">{{ cartData?.shippingAddress?.street }}
                </p>
                <p>{{ cartData?.shippingAddress?.postalCode }} {{ cartData?.shippingAddress?.city }}</p>
                <p>{{ cartData?.shippingAddress?.country }} {{ cartData?.shippingAddress?.region }}</p>
                <p>{{ cartData?.shippingAddress?.mobilePhone }}</p>
                <p>{{ cartData?.shippingAddress?.customerCode }}</p>
              </div>
            </div>
            <div class="error-address-tips flex-v-center h-[40px] mt-1" *ngIf="addressError">
              <svg-icon [iconName]="'new/info.svg'" class="mr-4"></svg-icon>
              {{"CART_ADDRESS_ERROR"|translate}}
            </div>
          </div>
          <!-- Shipment Dimensions-->
          <div class="font-bold mt-4 mb-1.5" *ngIf="cartData.shipmentDimension">
            {{"CART_DIMENSIONS"|translate}}
          </div>
          <div class="shipping_address_content bg-darkGrey" *ngIf="cartData.shipmentDimension">
            <p class="flex-between">
              <span>{{"CART_VOLUME"|translate}}</span><span>{{ cartData.shipmentDimension?.totalVolume }}
                {{ cartData.shipmentDimension?.unitOfVolume }}</span>
            </p>
            <p class="flex-between">
              <span> {{"CART_WEIGHT"|translate}}</span><span>{{
                cartData.shipmentDimension?.totalWeight }}
                {{ cartData.shipmentDimension?.unitOfWeight }}</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>